// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/open-arrow.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.commonDropDownButton{
    width: 15px;
    height: 15px;
    border-radius: 100%;
    flex-shrink: 0;

    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: 8px;
    background-position: center;
    background-repeat: no-repeat;
    transition-duration: 200ms;
}

.commonDropDownButton--open{
    transform: rotate(180deg);
}

.commonDropDownButton--inactive{
    opacity: 0.3;
    cursor: default;
}

.commonDropDownButtonColored{
    background: none;
    display: flex;
    justify-content: center;
    align-items: center;
}

.commonDropDownButton svg{
    fill: inherit;
}`, "",{"version":3,"sources":["webpack://./src/components/dropDown/DropDownButton.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,cAAc;;IAEd,yDAAoD;IACpD,oBAAoB;IACpB,2BAA2B;IAC3B,4BAA4B;IAC5B,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB","sourcesContent":[".commonDropDownButton{\n    width: 15px;\n    height: 15px;\n    border-radius: 100%;\n    flex-shrink: 0;\n\n    background-image: url('../../assets/open-arrow.svg');\n    background-size: 8px;\n    background-position: center;\n    background-repeat: no-repeat;\n    transition-duration: 200ms;\n}\n\n.commonDropDownButton--open{\n    transform: rotate(180deg);\n}\n\n.commonDropDownButton--inactive{\n    opacity: 0.3;\n    cursor: default;\n}\n\n.commonDropDownButtonColored{\n    background: none;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.commonDropDownButton svg{\n    fill: inherit;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
